import { requestFactory } from '@/plugins/axios'
// {id}
export function machineDel(id) {
   return requestFactory({
        url: `/machine/delete/${id}`,
        method: 'DELETE'
      }, true)
}
// {pageinfo}
export function changePage(params) {
  return requestFactory({
        url: '/machine/findList',
        method: 'GET',
        params: params
      })
}
// {machineid}
export function removeMachineById(params) {
  return requestFactory({
        url: '/machine/del',
        method: 'get',
        params: params
      })
}
